import './HiveTooltip.css';
export var body = '_1qgq9i10-2-0-1';